import {UserActor} from "interfaces";
import React from "react";

export const ModerationUserStatus = ({value}: { value?: UserActor }) => {
    if (!value) {
        return null;
    }

    return <span className="fw-normal"> {value.name} ({value.key}, {value.status})</span>
}